import { Button, DialogActions } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import React, { useContext, useState } from 'react';
import { MapDataContext } from '../context/map-data';
import { permissionsModal } from '../data/content';
import { InfoModal } from './info-modal';
import { ModalTitle } from './modal-title';
import { OrganisationValidations } from './organisation-validations';

interface ManagePrivateValidationsModalProps {
  open: boolean;
  handleClose: () => void;
  id: number | string | null;
}

export const ManagePrivateValidationsModal = ({ open, handleClose, id }: ManagePrivateValidationsModalProps) => {
  const [showInfoModal, setShowInfoModal] = useState(false)
  
  const { 
    fetchPrivateValidations,
  } = useContext(MapDataContext);


  const onClose = () => {
    fetchPrivateValidations()
    handleClose()
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
    >
      <ModalTitle onClose={onClose}>Manage private validations</ModalTitle>
      <DialogContent>
        <OrganisationValidations id={id} />
      </DialogContent>
      <>
        <DialogActions sx={{ pb: 3, px: 3 }}>
          <Button onClick={onClose}>Close</Button>
        </DialogActions>
      </>
      <InfoModal
        open={showInfoModal}
        title={permissionsModal.title}
        content={permissionsModal.content}
        maxWidth="sm"
        onClose={() => {
          setShowInfoModal(false)
        }}
      />
    </Dialog>
  );
}